import React from "react";

const LayoutBody3 = props => (
  <div className="layout-body layout-body-3">
    <div className="container">    
      <div className="row">
			  <div className="col-xs-12">
        <h6 className="header">{props.header}<span className="header-span">{props.header_span}</span></h6>
        </div>
      </div>  
      <div className="row bottom-xs layout-content">
			  <div className="col-xs-12 col-sm-8 col-lg-6 text">
          <h3>{props.title}</h3>
          <p>{props.paragraph}</p>
          <p>{props.paragraph_2}</p>
          <p>{props.paragraph_3}</p>
          <p>{props.paragraph_4}</p>
        </div>
        <div className="col-xs-12 col-sm-4 col-lg-6 image">
          <img alt="" src={props.image} />
        </div>
      </div>
    </div>
  </div>
);

export default LayoutBody3;